import { render, staticRenderFns } from "./UserSettingsAdmin.vue?vue&type=template&id=d908e0b4&"
import script from "./UserSettingsAdmin.vue?vue&type=script&lang=js&"
export * from "./UserSettingsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports